define([
	'react',
	'react-dom'
], function(React, ReactDOM) {

	class Details {
		constructor(options) {
			this.glassContext = options.glassContext;
			this.slideout = options.slideout;
			this.selectedObject = options.selectedObject;
			this.performAction = options.performAction;
			this.$el = (options.$el && options.$el[0]) || this._initDomElement();
			this.itemSpec = options.itemSpec;
			this.detailsView = null;
			this.isTeamContentRoot = options.isTeamContentRoot || false;
		}

		render() {
			const options = {
				glassContext: this.glassContext,
				selectedObject: this.selectedObject,
				performAction: this.performAction,
				isTeamContentRoot: this.isTeamContentRoot,
				slideout: this.slideout,
				onClose: () => { this.slideout && this.slideout.hide({ force: true }); }
			};
			this.$el.classList.add('ca-home-details');

			return new Promise((resolve, reject) => {
				require(['ca-content/home/caHome'], (caHome) => {
					this.detailsView = ReactDOM.render(React.createElement(caHome.DetailsView, options), this.$el);
					resolve();
				}, reject);
			});
		}

		//update the state on our react component
		updateSelection(selectedObject, glassContext, setFocus = false) {
			this.detailsView.updateSelection(selectedObject, glassContext, setFocus);
		}

		//slideout calls this when it closes
		remove() {
		}

		_initDomElement() {
			return document.createElement('div');
		}
	}

	return Details;
});